import { type FC } from 'react';

import {
  type LotteryTicketType,
  type TicketRewardType,
} from '@/common/types/lottery';

import { Picture } from '../Picture/Picture';

import diamondTicketPng from '/img/icons/ticket-diamond.png';
import diamondTicketWebp from '/img/icons/ticket-diamond.webp';
import goldTicketPng from '/img/icons/ticket-gold.png';
import goldTicketWebp from '/img/icons/ticket-gold.webp';
import silverTicketPng from '/img/icons/ticket-silver.png';
import silverTicketWebp from '/img/icons/ticket-silver.webp';

interface TicketIconProps {
  type: LotteryTicketType | TicketRewardType;
  className?: string;
}

const TicketIcon: FC<TicketIconProps> = ({ type, className }) => {
  const images: Record<
    LotteryTicketType | TicketRewardType,
    { img: string; webp: string; alt: string }
  > = {
    Silver: {
      img: silverTicketPng,
      webp: silverTicketWebp,
      alt: 'silver ticket',
    },
    silverTicket: {
      img: silverTicketPng,
      webp: silverTicketWebp,
      alt: 'silver ticket',
    },
    Gold: {
      img: goldTicketPng,
      webp: goldTicketWebp,
      alt: 'gold ticket',
    },
    goldTicket: {
      img: goldTicketPng,
      webp: goldTicketWebp,
      alt: 'gold ticket',
    },
    Diamond: {
      img: diamondTicketPng,
      webp: diamondTicketWebp,
      alt: 'diamond ticket',
    },
    diamondTicket: {
      img: diamondTicketPng,
      webp: diamondTicketWebp,
      alt: 'diamond ticket',
    },
  };

  return <Picture {...images[type]} className={className} />;
};

export { TicketIcon };
